
export const processFlowArray = [
  {
    id: 1,
    image: require('../images/ProcessFlow/ProcessFlowSensor.jpg'),
    alt: 'images/ProcessFlow/ProcessFlowSensor.jpg',
    title: 'HLZ Sensor Production Process Flow',
    text: '專業生產 Sensor，from 2"~65"',
    description: 'Sensor Process Flow',
  },
  {
    id: 2,
    image: require('../images/ProcessFlow/ProcessFlowTouch.jpg'),
    alt: 'images/ProcessFlow/ProcessFlowTouch.jpg',
    title: 'HLZ PCap Production Process Flow',
    text: '導入TP製程，具備完整觸摸屏產業鏈',
    description: 'PCap Process Flow',
  },
  {
    id: 3,
    image: require('../images/ProcessFlow/ProcessFlowTdm.jpg'),
    alt: 'images/ProcessFlow/ProcessFlowTdm.jpg',
    title: 'HLZ TDM Production Process Flow',
    text: '服務客戶投入TP+LCM全貼合生產線',
    description: 'Touch Display Module Process Flow',
    // link: 'https://www.hlztouch.com'
  }
]